// extracted by mini-css-extract-plugin
var _1 = "grecaptch-text__JgUh5";
var _2 = "grecaptcha__yXu3S";
export { _1 as "grecaptchText", _2 as "grecaptcha" }
